module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_delete.87c4f.png";